<template>
  <div class="desc-body">

    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>项目详情</el-breadcrumb-item>
      <!--      <quit-project />-->
    </el-breadcrumb>
    <!-- 主体部分 -->
    <el-card class="box-card" v-loading="loadingDesc">
      <el-descriptions title="" :column="1" style="font-size: 17px!important;">
        <el-descriptions-item label="项目号">{{ projectData.projectsRow.projectId }}</el-descriptions-item>
        <el-descriptions-item label="合同号信息">{{ projectData.projectsRow.contractNumber }}</el-descriptions-item>
        <el-descriptions-item label="otu数量">{{ projectPlus.otuNumber }}</el-descriptions-item>
        <el-descriptions-item label="属数量">{{ projectPlus.genusNumber }}</el-descriptions-item>
        <el-descriptions-item label="代谢物数量">{{ projectPlus.metaboliteNumber }}</el-descriptions-item>
        <el-descriptions-item label="DAM数量">{{ projectPlus.damNumber }}</el-descriptions-item>
        <el-descriptions-item label="样本数量">{{ projectPlus.sampleNumber }}</el-descriptions-item>
        <el-descriptions-item label="组数">{{ projectPlus.groupNumber }}</el-descriptions-item>
        <el-descriptions-item label="分析数量">{{ projectPlus.analyzeNumber }}</el-descriptions-item>
        <el-descriptions-item label="分析人员">{{ projectData.analyzer.userName }}</el-descriptions-item>
        <template v-for="(item ,index) in projectData.salerList">
          <el-descriptions-item :label="projectData.salerList.length===1?'销售姓名':'销售'+(index+1)+'姓名'">{{ item.userName }}</el-descriptions-item>
        </template>
        <template v-for="(item ,index) in projectData.customerList">
          <el-descriptions-item :label="projectData.customerList.length===1?'客户名称':'客户'+(index+1)+'名称'">{{ item.userName }}</el-descriptions-item>
          <el-descriptions-item :label="projectData.customerList.length===1?'客户手机号码':'客户'+(index+1)+'手机号码'">{{ item.userPhone }}</el-descriptions-item>
        </template>
        <el-descriptions-item label="创建时间">{{ projectData.projectsRow.createTime }}</el-descriptions-item>
        <el-descriptions-item label="分析结果下载" v-if="hasRes">
          <el-tooltip content="下载分析结果">
            <a target="#">
              <i class="el-icon-download downIcon" @click="getDownResZip"> </i>
            </a>
          </el-tooltip>
        </el-descriptions-item>
      </el-descriptions>

    </el-card>
  </div>
</template>

<script>
import QuitProject from '@/components/QuitProject'
import {downloadProgress} from "@/mixins/downloadProgress";
import {getDataInLocalStorage} from "@/utils/localStorageUtils";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  mixins: [downloadProgress],
  name: 'ProjectDesc',
  data() {
    return {
      loadingDesc: true,
      hasRes: false,
      projectPlus: '',
      projectId: '',
      projectData: {
        projectsRow: {
          projectId: '',
          createTime: ''
        },
        salerList: {
          userName: ''
        },
        customerList: {
          userName:'',
          userPhone: ''
        },
        analyzer: {
          userName: ''
        }
      }
    }
  },
  components: {
    "quit-project": QuitProject
  },
  created() {
    this.projectId = this.$route.query.projectId
    var projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
    this.getAllProjectDataById(this.projectId)
  },
  methods: {
    async getAllProjectDataById(projectId) {
      const {data: res} = await this.$http.get('project/' + projectId)
      this.loadingDesc = false
      this.projectData = res.projectAll
      this.projectPlus = res
      this.hasRes = res.hasRes
    },
    getDownResZip() {
      const url = `${baseURL}/project/downloadRes/${this.projectId}?token=${getDataInLocalStorage("token")}`
      const elink = document.createElement('a')
      elink.href = url
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink);
    },
  }
}
</script>

<style scoped>

.box-card {
  margin-top: 30px;
  height: 100%;
}

.desc-body {
  height: 90%;

}

.el-breadcrumb {
  line-height: 40px;
}

.downIcon:hover {
  color: green;
}

.downIcon {
  font-size: 21px;
}
</style>
